// extracted by mini-css-extract-plugin
module.exports = {"faSpin":"Spinner_faSpin__1jnGV","spinkf":"Spinner_spinkf__kM4SJ"};